<div class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" >

        <!-- CONTENT HEADER -->
        <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">Evaluaciones</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <span>Preiniciar Evaluacion</span>
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-50" fxLayout="column" fxFlex>

              <div fxLayout="column">

                    <div fxLayout="column" style="max-width:600px; margin:50px;">

                      <div fxFlex>
                        <mat-form-field  fxFlex>
                          <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre">
                        </mat-form-field>
                      </div>
                      <div fxFlex>
                        <mat-form-field  fxFlex>
                          <mat-label>Tipo de evaluación</mat-label>
                          <mat-select [(ngModel)]="LOCAL_DATA.tipo" class="roleSelect" (selectionChange)="selectTipo()"> 
                              <mat-option *ngFor="let tipoEvaluacion of tiposEvaluacion" [value]="tipoEvaluacion">
                                  {{tipoEvaluacion.nombre}}
                              </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div fxFlex>
                        <mat-label >Estructura jerárquica / Nodo:</mat-label>
                        <span *ngIf="LOCAL_DATA.nodoEstructuraJerarquica!=null" fxFlex class="px-20">{{LOCAL_DATA.estructuraJerarquica?.nombre}} / {{LOCAL_DATA.nodoEstructuraJerarquica?.nombre}}</span>
                        <button  style="margin-left:20px;" mat-button mat-raised-button (click)="openDialog()">Seleccionar Nodo</button>
                      </div>
                      <div fxFlex>
                        <mat-form-field  fxFlex>
                          <mat-label>Escenario</mat-label>
                          <mat-select [(ngModel)]="LOCAL_DATA.escenario" class="roleSelect">
                              <mat-option *ngFor="let escenario of escenarios" [value]="escenario">
                                  {{escenario.nombre}}
                              </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div fxFlex>

                        <mat-form-field  fxFlex>
                          <mat-label>Dueño</mat-label>
                          <mat-select [(ngModel)]="LOCAL_DATA.owner" class="roleSelect" >
                            <ng-container *ngFor="let usuario of LOCAL_DATA.nodoEstructuraJerarquica?.usuarios">
                              <mat-option *ngIf="esOwnersGroup(usuario)" [value]="usuario">
                                {{usuario.nombreCompleto}}
                              </mat-option>
                            </ng-container>
                              <!--<mat-option *ngFor="let usuario of LOCAL_DATA.nodoEstructuraJerarquica?.usuarios" [value]="usuario">
                                  {{usuario.nombreCompleto}}
                              </mat-option>-->
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div fxFlex>
                        <mat-form-field color="accent" appearance="fill">
                        <mat-label>Fecha de Inicio</mat-label>
                        <input matInput [matDatepicker]="picker1"
                        [min]="hoy"
                        [(ngModel)]="LOCAL_DATA.fechaInicio">
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div fxFlex>

                        <mat-form-field color="accent" appearance="fill">
                        <mat-label>Fecha de Finalización</mat-label>
                        <input matInput [matDatepicker]="picker2"
                        [min]="LOCAL_DATA.fechaInicio" [disabled]="LOCAL_DATA.fechaInicio==null"
                        [(ngModel)]="LOCAL_DATA.fechaFin">
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div fxFlex>

                        <button mat-raised-button color="accent" class="submit-button" aria-label="Crear"
                                 (click)="addEvaluacion()" [disabled]="LOCAL_DATA.owner==null || LOCAL_DATA.escenario==null || LOCAL_DATA.nodoEstructuraJerarquica==null || LOCAL_DATA.nombre=='' || LOCAL_DATA.tipo==null">
                            Guardar
                        </button>
                      </div>

                    </div>




              </div>



            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
